(function(){
function initMto(root){
  if (root.dataset.ready) return; root.dataset.ready = '1';
  var SID = root.dataset.section;
  var $ = function(s, el){ return (el || root).querySelector(s); };
  var $$ = function(s, el){ return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var OPTS = JSON.parse($('[data-mto-options]').textContent);
  var EX = JSON.parse($('[data-mto-extras-json]').textContent);
  var EXT_I = +root.dataset.ext, REV_I = +root.dataset.rev, LEAD = root.dataset.lead;
  var guided = root.dataset.layout === 'guided';
  var cur = 0, done = {}, view = null;
  var exState = EX.map(function(){ return { key: null, qty: 0 }; });
  var V = readVariant(document);

  function fmt(c){
    var whole = c % 100 === 0;
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(c / 100); }
    catch(e){ return (c / 100).toFixed(whole ? 0 : 2); }
  }
  function readVariant(doc){ var s = doc.querySelector('[data-mto="' + SID + '"] [data-mto-variant]') || doc.querySelector('[data-mto-variant]'); return JSON.parse(s.textContent); }
  function el(tag, cls, text){ var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  /* ---------- options via Section Rendering API ---------- */
  function selectedIds(){
    return OPTS.map(function(_, i){
      var w = $('[data-opt-wrap="' + i + '"]'); if (!w) return null;
      var s = $('select[data-opt]', w); if (s) return s.value;
      var b = $('[data-ov][aria-pressed="true"]', w); return b ? b.dataset.ov : null;
    });
  }
  function selectedNames(){
    return OPTS.map(function(_, i){
      var w = $('[data-opt-wrap="' + i + '"]'); if (!w) return null;
      var s = $('select[data-opt]', w); if (s) return s.options[s.selectedIndex].dataset.name;
      var b = $('[data-ov][aria-pressed="true"]', w); return b ? b.dataset.name : null;
    });
  }
  var VARS = (function(){ var s = $('[data-mto-variants]'); try { return s ? JSON.parse(s.textContent) : []; } catch(e){ return []; } })();
  /* Pick the variant that keeps every choice up to option i and as many later choices as possible */
  function bestVariant(names, i){
    var best = null, score = -1;
    VARS.forEach(function(v){
      for (var k = 0; k <= i; k++) if (v[1][k] !== names[k]) return;
      var sc = 0; for (var j = i + 1; j < names.length; j++) if (v[1][j] === names[j]) sc += Math.pow(2, names.length - j);
      if (sc > score) { score = sc; best = v; }
    });
    return best;
  }
  function fetchSection(variantId){
    var url = root.dataset.url + '?section_id=' + SID + '&variant=' + variantId;
    return fetch(url).then(function(r){ return r.text(); }).then(function(t){ return new DOMParser().parseFromString(t, 'text/html'); });
  }
  function choose(i, id, name){
    var names = selectedNames();
    names[i] = name;
    var target = bestVariant(names, i);
    if (!target) { status('That combination is not available. Please choose another option.', true); return; }
    var cfg = $('[data-mto-cfg]'); cfg.classList.add('is-loading');
    fetchSection(target[0]).then(function(doc){
      var nc = doc.querySelector('[data-mto-cfg]'); if (nc) cfg.innerHTML = nc.innerHTML;
      var nd = doc.querySelector('[data-mto-draw]'), od = $('[data-mto-draw]'); if (nd && od) od.innerHTML = nd.innerHTML;
      V = readVariant(document);
      try { var u = new URL(location.href); u.searchParams.set('variant', V.id); history.replaceState(null, '', u); } catch(e){}
      touch(i); render();
    }).catch(function(){ status('Sorry, something went wrong. Please try again.', true); })
      .finally(function(){ cfg.classList.remove('is-loading'); });
  }
  root.addEventListener('click', function(e){
    var b = e.target.closest('[data-ov]');
    if (b && root.contains(b)) { if (b.getAttribute('aria-pressed') === 'true') { touch(+b.dataset.opt); wiz(); return; } choose(+b.dataset.opt, b.dataset.ov, b.dataset.name); return; }
    if (e.target.closest('[data-next]')) { touch(cur); go(Math.min(REV_I, cur + 1)); return; }
    if (e.target.closest('[data-back]')) { go(Math.max(0, cur - 1)); return; }
    if (e.target.closest('[data-mto-seedrawing]')) { showDrawing(); return; }
  });
  root.addEventListener('change', function(e){
    var s = e.target.closest('select[data-opt]');
    if (s) choose(+s.dataset.opt, s.value, s.options[s.selectedIndex].dataset.name);
  });

  /* ---------- gallery ---------- */
  var hero = $('[data-mto-hero]'), heroImg = $('[data-mto-hero] img'), cap = $('[data-mto-cap]'), dwt = $('[data-mto-dwthumb]');
  function setHero(src, isDrawing, btn){
    if (!heroImg) return;
    heroImg.removeAttribute('srcset'); heroImg.src = src;
    hero.classList.toggle('is-drawing', !!isDrawing);
    cap.hidden = !isDrawing; if (isDrawing) cap.textContent = V.options.join(' · ');
    $$('[data-mto-thumbs] button').forEach(function(t){ t.setAttribute('aria-current', t === btn ? 'true' : 'false'); });
  }
  $$('[data-mto-thumbs] button[data-src]').forEach(function(t){ t.addEventListener('click', function(){ view = null; setHero(t.dataset.src, false, t); }); });
  if (dwt) dwt.addEventListener('click', showDrawing);
  function showDrawing(){ if (V.drawing) { view = 'd'; setHero(V.drawing, true, dwt); if (window.innerWidth < 900) hero.scrollIntoView({ behavior: 'smooth' }); } }
  function syncDrawing(){
    if (!dwt) return;
    dwt.hidden = !V.drawing; if (V.drawing) $('img', dwt).src = V.drawing;
    if (view === 'd') { if (V.drawing) setHero(V.drawing, true, dwt); else { var f = $('[data-mto-thumbs] button[data-src]'); if (f) setHero(f.dataset.src, false, f); view = null; } }
    var dl = $('[data-mto-drawlink]'), dr = $('[data-mto-draw] .mto-dcard'); if (dl) dl.hidden = !dr;
  }

  /* ---------- extras ---------- */
  function exOptions(x){
    var lock = {};
    x.opts.forEach(function(n, k){ var mi = OPTS.indexOf(n); if (mi >= 0 && x.v.some(function(v){ return v[2][k] === V.options[mi]; })) lock[k] = V.options[mi]; });
    var cand = x.v.filter(function(v){ return Object.keys(lock).every(function(k){ return v[2][k] === lock[k]; }); });
    var free = x.opts.map(function(_, k){ return k; }).filter(function(k){ return !(k in lock); });
    var combos = cand.map(function(v){ return { label: free.map(function(k){ return v[2][k]; }).join(' · ') || x.title, v: v }; });
    return { lock: lock, combos: combos };
  }
  function renderExtras(){
    var box = $('[data-mto-extras]'); if (!box) return;
    box.replaceChildren();
    EX.forEach(function(x, i){
      var o = exOptions(x), st = exState[i];
      if (!o.combos.length) { st.qty = 0; return; }
      if (!o.combos.some(function(c){ return c.label === st.key; })) st.key = o.combos[0].label;
      var c = o.combos.filter(function(c){ return c.label === st.key; })[0];
      var card = el('div', 'mto-extra');
      var img = el('img'); img.alt = ''; if (x.img) img.src = x.img; card.appendChild(img);
      var info = el('div'); info.appendChild(el('div', 't', x.title));
      var locked = Object.keys(o.lock).map(function(k){ return o.lock[k]; });
      info.appendChild(el('div', 'd', locked.length ? 'In your ' + locked.join(', ') : '')); card.appendChild(info);
      card.appendChild(el('div', 'p', fmt(c.v[1]) + (st.qty > 1 ? ' each' : '')));
      var ctl = el('div', 'ctl');
      if (o.combos.length > 1) {
        var sel = el('select'); sel.setAttribute('aria-label', x.title + ' option');
        o.combos.forEach(function(cc){ var op = el('option', null, cc.label + ' · ' + fmt(cc.v[1])); op.value = cc.label; op.selected = cc.label === st.key; sel.appendChild(op); });
        sel.addEventListener('change', function(){ st.key = sel.value; touch(EXT_I); render(); });
        ctl.appendChild(sel);
      }
      var q = el('div', 'mto-qty'), mi = el('button', null, '−'), qs = el('span', null, st.qty), pl = el('button', null, '+');
      mi.type = pl.type = 'button'; mi.setAttribute('aria-label', 'Fewer ' + x.title); pl.setAttribute('aria-label', 'More ' + x.title);
      mi.onclick = function(){ st.qty = Math.max(0, st.qty - 1); render(); };
      pl.onclick = function(){ st.qty = Math.min(20, st.qty + 1); touch(EXT_I); render(); };
      q.append(mi, qs, pl); ctl.appendChild(q); card.appendChild(ctl);
      box.appendChild(card);
    });
  }
  function chosenExtras(){
    var out = [];
    EX.forEach(function(x, i){
      var st = exState[i]; if (!st.qty) return;
      var c = exOptions(x).combos.filter(function(c){ return c.label === st.key; })[0];
      if (c) out.push({ id: c.v[0], qty: st.qty, price: c.v[1], label: x.title + (c.label !== x.title ? ', ' + c.label : '') });
    });
    return out;
  }

  /* ---------- summary + cart ---------- */
  function status(t, err){ var s = $('[data-mto-status]'); s.textContent = t; s.classList.toggle('err', !!err); }
  function renderSummary(){
    var lines = $('[data-mto-lines]'); lines.replaceChildren();
    var total = V.price;
    var main = el('div', 'mto-line'); main.append(el('span', null, OPTS.length ? V.options.join(', ') : root.dataset.title), el('span', null, fmt(V.price))); lines.appendChild(main);
    chosenExtras().forEach(function(x){ total += x.price * x.qty; var l = el('div', 'mto-line'); l.append(el('span', null, (x.qty > 1 ? x.qty + ' × ' : '') + x.label), el('span', null, fmt(x.price * x.qty))); lines.appendChild(l); });
    $('[data-mto-total]').textContent = fmt(total);
    var stt = $('[data-mto-sticky-total]'); if (stt) stt.textContent = fmt(total);
    var talk = $('[data-mto-talk]');
    if (talk && root.dataset.consult) { var sep = root.dataset.consult.indexOf('?') > -1 ? '&' : '?'; talk.href = root.dataset.consult + sep + 'enquiry=' + encodeURIComponent(root.dataset.title + ': ' + V.options.join(', ') + chosenExtras().map(function(x){ return '; ' + x.qty + ' × ' + x.label; }).join('')); }
    return total;
  }
  function addToCart(){
    var btns = $$('[data-mto-atc],[data-mto-sticky-btn]'); btns.forEach(function(b){ b.disabled = true; });
    var props = LEAD ? { 'Lead time': LEAD } : {};
    var items = [{ id: V.id, quantity: 1, properties: props }].concat(chosenExtras().map(function(x){ return { id: x.id, quantity: x.qty, properties: props }; }));
    fetch(root.dataset.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){
        status('Added to your basket.');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: {} } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        if (window.theme && theme.settings && theme.settings.cartType === 'page') window.location.href = root.dataset.cart;
      })
      .catch(function(e){ status((e && (e.description || e.message)) || 'Could not add to basket. Please try again.', true); })
      .finally(function(){ btns.forEach(function(b){ b.disabled = false; }); });
  }
  $('[data-mto-atc]').addEventListener('click', addToCart);
  var sb = $('[data-mto-sticky-btn]'); if (sb) sb.addEventListener('click', addToCart);

  /* ---------- wizard ---------- */
  var LABELS = OPTS.slice(); if (EXT_I !== REV_I) LABELS.push(root.dataset.extrasTitle || 'Extras'); LABELS.push('Review');
  function touch(i){ done[i] = true; var all = true; for (var k = 0; k < REV_I; k++) if (!done[k]) all = false; if (all) done[REV_I] = true; }
  function chosenText(i){
    if (i < OPTS.length) return V.options[i] || '';
    if (i === EXT_I && EXT_I !== REV_I) { var x = chosenExtras(); return x.length ? x.map(function(e){ return e.qty + ' × ' + e.label.split(',')[0]; }).join(', ') : (done[i] ? 'None' : ''); }
    return done[REV_I] ? 'Ready' : '';
  }
  function go(i){ cur = i; wiz(); if (guided) { var w = $('[data-mto-wiz]'); var r = w.getBoundingClientRect(); if (r.top < 0) w.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
  function wiz(){
    var ol = $('[data-mto-steps]'); if (!ol) return;
    ol.replaceChildren();
    var reach = 0; Object.keys(done).forEach(function(k){ reach = Math.max(reach, +k + 1); });
    LABELS.forEach(function(n, i){
      var li = el('li', (done[i] ? 'done ' : '') + (i === cur && guided ? 'active' : ''));
      var b = el('button'); b.type = 'button';
      var num = el('span', 'num', done[i] && i !== cur ? '✓' : String(i + 1)), lbl = el('span', 'lbl', n), ch = el('span', 'chosen', (done[i] || i <= cur) ? chosenText(i) : '');
      b.append(num, lbl, ch);
      if (i === cur && guided) b.setAttribute('aria-current', 'step');
      if (guided && i > Math.max(cur, reach)) b.disabled = true;
      b.addEventListener('click', function(){ if (guided) go(i); else { var t = $('.mto-step[data-step="' + i + '"]') || $('[data-mto-summary]'); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); } });
      li.appendChild(b); ol.appendChild(li);
    });
    var pct = Math.round(Object.keys(done).length / LABELS.length * 100);
    $('[data-mto-bar]').style.width = pct + '%';
    $('[data-mto-count]').textContent = (guided ? 'Step ' + (cur + 1) + ' of ' + LABELS.length + ' · ' : '') + pct + '% complete · ' + $('[data-mto-total]').textContent;
    $$('.mto-step').forEach(function(s){ s.classList.toggle('on', +s.dataset.step === cur); });
    var rv = $('[data-mto-review]');
    rv.classList.toggle('on', cur === REV_I);
    if (cur === REV_I) {
      rv.replaceChildren();
      LABELS.slice(0, REV_I).forEach(function(n, i){
        var row = el('div', 'mto-rrow'), t = el('span'); t.append(el('b', null, n + ': '), document.createTextNode(chosenText(i) || 'None'));
        var c = el('button', 'mto-link', 'Change'); c.type = 'button'; c.onclick = function(){ go(i); };
        row.append(t, c); rv.appendChild(row);
      });
    }
    // In guided mode the summary is always visible so the price never hides; the review step just confirms choices.
  }
  $$('[data-mode]').forEach(function(b){ b.addEventListener('click', function(){ guided = b.dataset.mode === 'guided'; root.classList.toggle('mto--guided', guided); root.classList.toggle('mto--all', !guided); $$('[data-mode]').forEach(function(x){ x.setAttribute('aria-pressed', x === b); }); wiz(); }); b.setAttribute('aria-pressed', (b.dataset.mode === 'guided') === guided); });

  /* ---------- sticky mobile bar ---------- */
  var sticky = $('[data-mto-sticky]'), summary = $('[data-mto-summary]');
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(en){ sticky.hidden = en[0].isIntersecting; }).observe(summary);
  }

  function render(){ renderExtras(); renderSummary(); syncDrawing(); wiz(); status(''); }
  render();
}
function boot(){ Array.prototype.forEach.call(document.querySelectorAll('[data-mto]'), initMto); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();